import { h, Component } from 'preact';

import './index.less';
import EventBus from '../../lib/EventBus';
import Search from '../../molecules/Icon/Search';
import { cdnHost } from '../../../config';
import { addClass, removeClass } from '../../lib/Dom';

class AddressPicker extends Component {
  constructor (props) {
    super(props);
    this.state = {
      selectedAddressValue: '',
      searchTerm: '',
      isVisible: false,
      placeHolderText: '',
      listEndComponent: null,
      onSelect: () => {},
      addressComponentList: []
    };
  }

  componentDidMount () {
    EventBus.addListener(EventBus.TYPE.SHOW_ADDRESS_PICKER, this.onShow);
    EventBus.addListener(EventBus.TYPE.HIDE_ADDRESS_PICKER, this.onHide);
    EventBus.addListener(EventBus.TYPE.ROUTE_CHANGE, this.onRouteChange);
  }

  componentDidUpdate (previousProps, previousState) {
    const { isVisible, selectedAddressValue } = this.state;
    try {
      if (selectedAddressValue && this.addressListRef) {
        const countryItemElement = document.querySelector(
          `.country-item-${selectedAddressValue.replace(/ /g, '').replace(/&/g, '')}`
        );
        if (countryItemElement) {
          this.addressListRef.scrollTo(
            0,
            countryItemElement.offsetTop - this.addressListRef.offsetTop
          );
        }
      }
      if (
        isVisible &&
        !previousState.isVisible &&
        this.searchInput &&
        typeof this.searchInput.focus === 'function'
      ) {
        this.searchInput.focus();
      }
    } catch (error) {
      // Do nothing
    }
  }

  componentWillUnmount () {
    EventBus.removeListener(EventBus.TYPE.SHOW_ADDRESS_PICKER, this.onShow);
    EventBus.removeListener(EventBus.TYPE.HIDE_ADDRESS_PICKER, this.onHide);
    EventBus.removeListener(EventBus.TYPE.ROUTE_CHANGE, this.onRouteChange);
    removeClass(document.querySelector('body'), 'block-scroll');
  }

  onShow = ({
    existingAddress,
    onSelect,
    addressList,
    placeHolderText,
    listEndComponent = null
  } = {}) => {
    this.setState(
      (prev) => ({
        ...prev,
        selectedAddressValue: existingAddress || '',
        isVisible: true,
        placeHolderText,
        listEndComponent,
        onSelect,
        addressComponentList: addressList
      }),
      () => {
        addClass(document.querySelector('body'), 'block-scroll');
      }
    );
  };

  onHide = () => {
    this.setState(
      (prev) => ({
        ...prev,
        isVisible: false,
        selectedAddressValue: '',
        searchTerm: '',
        placeHolderText: '',
        listEndComponent: null,
        onSelect: () => {},
        addressComponentList: []
      }),
      () => {
        removeClass(document.querySelector('body'), 'block-scroll');
      }
    );
  };

  onRouteChange = () => {
    EventBus.notify(EventBus.TYPE.HIDE_ADDRESS_PICKER);
  };

  onSearchChange = (e) => {
    this.setState((prev) => ({ ...prev, searchTerm: e.target.value }));
  };

  onAddressComponentSelect = (addressData) => {
    const { onSelect } = this.state;
    if (typeof onSelect === 'function') {
      onSelect(addressData);
    }
    EventBus.notify(EventBus.TYPE.HIDE_ADDRESS_PICKER);
  };

  onClosePress = () => {
    EventBus.notify(EventBus.TYPE.HIDE_ADDRESS_PICKER);
  };

  getFilteredAddressList = () => {
    const { searchTerm, addressComponentList = [] } = this.state;
    if (typeof searchTerm !== 'string' || searchTerm.trim().length === 0) {
      return addressComponentList || [];
    }
    return (addressComponentList || []).filter(
      (addressComponent) =>
        addressComponent.name.trim().toLowerCase().indexOf(searchTerm.trim().toLowerCase()) !== -1
    );
  };

  render () {
    const { searchTerm, selectedAddressValue, isVisible, placeHolderText, listEndComponent } =
      this.state;

    const addressComponentList = this.getFilteredAddressList();

    return (
      <div
        className="country-picker-container"
        style={{
          display: isVisible ? undefined : 'none',
          opacity: isVisible ? undefined : '0',
          height: isVisible ? undefined : '0px',
          width: isVisible ? undefined : '0px'
        }}
      >
        <div className="country-picker">
          <div className="search-bar">
            <div className="search-icon">
              <Search size={20} color="#aaa" />
            </div>

            <div className="input-container">
              <input
                ref={(element) => (this.searchInput = element)}
                type="text"
                placeholder={placeHolderText}
                autoComplete="new-password"
                value={searchTerm}
                onChange={this.onSearchChange}
              />
            </div>

            <div className="close-icon" onClick={this.onClosePress}>
              <img alt src={`${cdnHost}assets/close-black.svg`} />
            </div>
          </div>

          <div ref={(element) => (this.addressListRef = element)} className="country-list">
            {addressComponentList.map((addressComponent, index) => (
              <div
                key={index}
                className={`country-item country-item-${
                  addressComponent.id
                } country-item-${addressComponent.name.replace(/ /g, '').replace(/&/g, '')} ${
                  selectedAddressValue === addressComponent.name ? 'selected' : ''
                }`}
                onClick={() => this.onAddressComponentSelect(addressComponent)}
              >
                <div className="name">{addressComponent.name}</div>
              </div>
            ))}
            {listEndComponent}
          </div>
        </div>
      </div>
    );
  }
}

export default AddressPicker;
